import * as Yup from 'yup'
import { REGEX_FULLDOMAIN, REGEX_SUBDOMAIN } from '../../../constants'

const checkNoDuplicate = (domains = [], value = '') =>
  !value || !domains.some((d) => d.domain?.toLowerCase() === value.toLowerCase())

export const getCustomDomainSchema = (domains) =>
  Yup.object().shape({
    dnsAddress: Yup.object().shape({
      domain: Yup.string()
        .matches(REGEX_FULLDOMAIN, 'Please enter a valid domain (e.g. my domain.com)')
        .required('Please enter a domain')
        .test('domain', 'Domain already added', (value) => checkNoDuplicate(domains, value)),
      selected: Yup.string().required('Please select an option'),
      checked: Yup.boolean(),
      subdomain: Yup.string().when('checked', {
        is: true,
        then: Yup.string()
          .matches(REGEX_SUBDOMAIN, 'Please enter a valid subdomain')
          .required('Please enter your subdomain'),
        otherwise: Yup.string()
      })
    }),
    path: Yup.object().shape({
      selected: Yup.string(),
      confirmNoRefund: Yup.boolean().oneOf([true], 'You must confirm that no refund is available')
    }),
    wizard: Yup.object().shape({
      selected: Yup.string().required('Please select an option')
    }),
    dnsRecords: Yup.object().shape({
      checked: Yup.boolean().required('Please select an option')
    }),
    registrantContact: Yup.object().shape({
      RegistrantFirstName: Yup.string().required('First name is required'),
      RegistrantLastName: Yup.string().required('Last name is required'),
      RegistrantEmailAddress: Yup.string().email('Invalid email address').required('Email address is required'),
      RegistrantPhone: Yup.string()
        .required('Phone number is required')
        .matches(/^\+\d{1,3}\s?\d{4,14}$/, 'Please enter a valid phone number with country code (e.g., +1 2025551234)'),
      RegistrantAddress1: Yup.string().required('Address is required'),
      RegistrantCity: Yup.string().required('City is required'),
      RegistrantStateProvince: Yup.string().required('State/Province is required'),
      RegistrantPostalCode: Yup.string().required('Postal code is required'),
      RegistrantCountry: Yup.string().required('Country is required')
    })
  })
